import { Drawer, IconButton, useMediaQuery } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import useComponentSize from '@rehooks/component-size';
import classNames from 'classnames';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppNavList } from '~/common/nav-list';
import { toggleNawDrawerAction } from '~/features/dashboard/store/actions';
import { selectNawDrawerState } from '~/features/dashboard/store/selectors';
import { mediaQuery } from '~/styles/media-query';
import css from './styles.module.scss';

interface NavDrawerProps {}

export const NavBlock: React.FC<NavDrawerProps> = ({ children }) => {
    const ref = useRef<HTMLDivElement>(null);
    const PaperProps = useMemo(() => {
        return {
            ref,
            className: css.paper,
        };
    }, []);

    const { width } = useComponentSize(ref);

    const isDesktop = useMediaQuery(mediaQuery.desktop);

    const dispatch = useDispatch();

    useEffect(() => {
        isDesktop && dispatch(toggleNawDrawerAction(true));
    }, [dispatch, isDesktop]);

    const navDrawerGlobalState = useSelector(selectNawDrawerState);

    const styles = useMemo(() => {
        return {
            width: navDrawerGlobalState ? width : 0,
        };
    }, [navDrawerGlobalState, width]);

    const handleToggleDrawer = useCallback(() => {
        dispatch(toggleNawDrawerAction());
    }, [dispatch]);

    const ModalProps = useMemo(() => {
        return {
            keepMounted: true, // Better open performance on mobile.
        };
    }, []);

    return (
        <Drawer
            className={css.module}
            style={styles}
            open={navDrawerGlobalState}
            PaperProps={PaperProps}
            variant={isDesktop ? 'persistent' : 'temporary'}
            ModalProps={ModalProps}
        >
            {/* {isDesktop && <Toolbar />} */}
            {!isDesktop && (
                <IconButton className={classNames(css.menuButton)} aria-label="close drawer" onClick={handleToggleDrawer}>
                    <ChevronLeftIcon />
                </IconButton>
            )}
            {children}
            {!isDesktop && <AppNavList />}
        </Drawer>
    );
};
